// extracted by mini-css-extract-plugin
module.exports = {"level_0":"IndexScreen_level_0__MjoRq","level_1":"IndexScreen_level_1__19-ZB"};